import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom/client'; // Dodaj import za ReactDOM
import {
  TabulatorFull as Tabulator,
  ResizeColumnsModule,
} from 'tabulator-tables';
import 'tabulator-tables/dist/css/tabulator.min.css'; // Tabulator styles
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import { applyPlugin } from 'jspdf-autotable';

applyPlugin(jsPDF);

Tabulator.registerModule([ResizeColumnsModule]);
const ReactTabulator = React.forwardRef((props, ref) => {
  const tableRef = useRef(null);

  useEffect(() => {
    if (tableRef.current) {
      // Ensure that columns and data are not undefined or null
      const columns = props.columns || [];
      const data = props.data || [];

      const tableColumns = columns.map((col) => {
        const hasValueFormatter = typeof col.valueFormatter === 'function';
        const hasRenderCell = typeof col.renderCell === 'function';
        if (hasRenderCell || hasValueFormatter) {
          return {
            ...col,
            formatter: (cell) => {
              const cellElement = cell.getElement(); // Dohvati DOM element ćelije
              const cellValue = cell.getValue();
              const cellData = cell.getData();

              // Kreiraj React root za ćeliju
              const reactRoot = ReactDOM.createRoot(cellElement);

              if (hasRenderCell) {
                // Renderuj React komponentu
                reactRoot.render(
                  col.renderCell({ value: cellValue, row: cellData }),
                );
              }

              if (hasValueFormatter) {
                reactRoot.render(col.valueFormatter({ value: cellValue }));
              }
              // Vraćanje sadržaja iz `formatter` nije potrebno
              return '';
            },
            cellClick: (e, cell) => {
              // Ako je potreban dodatni event handler za ćeliju
              console.log('Kliknuta ćelija:', cell.getData());
            },
            // cellDestroyed: (cell) => {
            //   if (cell.reactRoot) {
            //     cell.reactRoot.unmount();
            //     delete cell.reactRoot;
            //   }
            // },
          };
        }
        return { ...col, resizable: true };
      });
      let tableInstance;
      try {
        // Create Tabulator instance
        tableInstance = new Tabulator(tableRef.current, {
          ...props.options,

          data: data,
          columns: tableColumns,
          layout: 'fixed',
          // rowHeight: 'auto',
          autoResize: false,
          rowHeight: props.comfort ? 66 : 36,
          dependencies: {
            XLSX: XLSX, // Poveži XLSX biblioteku sa Tabulator-om
            // eslint-disable-next-line new-cap
            jsPDF: () => new jsPDF(), // Povezivanje jsPDF-a sa Tabulator-om
          },
          // footerElement: `<span id="table-footer" style="padding: 0px; font-weight: bold;text-align:center">Count: ${data.length}</span>`,
        });

        if (ref) {
          ref.current = tableInstance; // Set the Tabulator instance to ref
        }
      } catch (error) {
        console.error('Error initializing Tabulator:', error);
      }
    }
    // return () => tableInstance.destroy();
  }, [props.data]);

  return (
    <div ref={tableRef} className={props.comfort ? 'tabulator-comfort' : ''} /> // className dodat naknadno
  );
});

export default ReactTabulator;
